export default __webpack_public_path__ + "static/media/24-1_commentdots.ba6e1bf4.svg";